
export interface ICompanySocialLink {
  socialLink: string;
}

export interface IBasicInformation {
  company_name: string;
  companyPhone: string;
  countryId: number | null;
  industrytypeId: number | null;
  sourceId: number | null;
  agencyPocId?: number | null;
  contactPersonName: string;
  designationId: number | null;
  companyEmail: string;
  websiteUrl?: string;
  companySize?: string;
  // destinationMarket?: string;
  socialLinks: ICompanySocialLink[];
}

export interface MarketingChannel {
  channel: string;
  budget: string;
}

// export interface IBusinessDetails {
//   businessType: number | null;
//   yearsInBusiness: number | string;
//   businessChallenges: string;
//   existingMarketingBudget?: string;

//   currentMarketingChannels: MarketingChannel[];
//   competitors: string[];
// }

export interface MarketingChannel {
  channelType: number | null;
  budget: string;
}

export interface IBusinessDetails {
  businessType: number | null;
  yearsInBusiness: string;
  businessChallenges: string;
  existingMarketingBudget?: string | null;

  currentMarketingChannels: MarketingChannel[];
  competitors: string[];
}

export interface IDecisionInternalSales {
  decisionMakerName: string;
  decisionMakerRole: string;
  approvalTimeline: string;
  preferredCommunicationMode: string;
  priorityLevel: string;
  assignedSalesPerson: string;
  internalNotes: string;
  urgencyLevel: string;
  attachments: string;
}

// export interface IGoalsBudget {
//   primaryGoal: string;
//   monthlyLeadTarget: string;
//   revenueGoal: string;
//   estimatedBudget: string;
//   monthlyOrOneTime: string;
//   projectTimeline: string;
//   expectedStartDate: string;
//   urgencyLevel: string;
//   kpiExpectations: string;
// }

export interface IGoalsBudget {
  primaryGoal: string;
  expectedStartDate: string;
  monthlyLeadTarget: string;
  urgencyLevel: string;
  revenueGoal: string;
  kpiExpectations: string;
  estimatedBudget: string;
  budgetType: string;
  projectTimeline: string;
  monthlyOrOneTime: string;
}


export interface IServiceRequirements {
  seo: ISeoForm;
  googleAds: IGoogleAds;
  metaAds: IMetaAds;
  websiteDevelopment: IWebDevelopment;
  socialMedia: ISocialMedia;
  branding: IBranding;
  appDevelopment: IAppDevelopment;
}

export interface ISeoForm {
  primarySeoGoal: string;
  targetKeywords: string;
  targetLocations: string;
  targetAudience: string;
  competitorWebsites: string;
  currentWebsiteTraffic: string;
  existingRankings: string;
  previousSeoDone: string;
  existingSeoAgency: string;
  googleSearchConsoleAccess: string;
  googleAnalyticsAccess: string;
  websiteSpeedIssues: string;
  mobileFriendly: string;
  sitemapAvailable: string;
  blogSectionAvailable: string;
  blogWritingNeeded: string;
  landingPagesNeeded: string;
  servicePagesNeeded: string;
  contentResponsibility: string;
  existingBacklinks: string;
  spamPenaltyIssues: string;
  guestPostingAllowed: string;
}

export interface IGoogleAds {
  campaignObjective: string;
  existingGoogleAdsAccount: string;
  existingCampaignRunning: string;
  monthlyAdBudget: string;
  targetLocations: string;
  targetAudience: string;
  adStrategy: string;
  conversionTrackingSetup: string;
  googleTagManagerAccess: string;
  analyticsAccess: string;
  landingPageAvailable: string;
  currentCpl: string;
  currentRoas: string;
  existingConversionRate: string;
  previousAgency: string;
}

export interface IMetaAds {
  facebookPageAvailable: string;
  instagramAccountAvailable: string;
  metaBusinessManagerAccess: string;
  existingCampaignRunning: string;
  targetAgeGroup: string;
  gender: string;
  interests: string;
  locations: string;
  adGoal: string;
  creativesAvailable: string;
  videoContentAvailable: string;
  contentSupportNeeded: string;
  monthlyBudget: string;
  currentRoas: string;
  existingPixelSetup: string;
  conversionApiSetup: string;
}

export interface IWebDevelopment {
  websiteType: string;
  numberOfPages: string;
  requiredFeatures: string;
  existingWebsite: string;
  domainAvailable: string;
  hostingAvailable: string;
  referenceWebsites: string;
  preferredDesignStyle: string;
  brandGuidelinesAvailable: string;
  mobileResponsiveRequired: string;
  darkModeRequired: string;
  budget: string;
  adminPanelRequired: string;
  paymentGateway: string;
  userLogin: string;
  crmIntegration: string;
  blogRequired: string;
  chatIntegration: string;
  preferredTechnology: string;
  cmsPreference: string;
  seoFriendlyStructure: string;
  multilingualSupport: string;
  deadline: string;
  maintenanceRequired: string;
}

export interface ISocialMedia {
  facebook: string;
  instagram: string;
  linkedin: string;
  twitter: string;
  youtube: string;
  postingFrequency: string;
  contentType: string;
  contentApprovalWorkflow: string;
  paidPromotionsNeeded: string;
  influencerMarketingNeeded: string;
  brandTone: string;
  competitors: string;
  existingBrandKit: string;
  followersGrowth: string;
  engagement: string;
  leads: string;
  reach: string;
}

export interface IAppDevelopment {
  platform: string;
  appType: string;
  loginSignup: string;
  payments: string;
  notifications: string;
  chat: string;
  maps: string;
  adminPanel: string;
  apiIntegration: string;
  thirdPartyIntegrations: string;
  scalabilityRequirements: string;
  wireframeAvailable: string;
  designRequired: string;
  existingAppPreference: string;
  launchTimeline: string;
  budget: string;
  maintenanceSupport: string;
}
export interface IBranding {
  brandName: string;
  tagline: string;
  businessIndustry: string;
  targetAudience: string;
  competitorBrands: string;
  brandColors: string;
  typography: string;
  budgetRange: string;
  brandTone: string;

  existingLogo: string;
  logoDesignNeeded: string;
  brandGuidelines: string;
  socialMediaKit: string;
  packagingDesign: string;
  businessCardNeeded: string;
  stationeryDesign: string;
  printAssets: string;
  digitalAssets: string;
}

const defaultBasicInfo: IBasicInformation = {
  company_name: "",
  companyPhone: "",
  websiteUrl: "",
  countryId: null,
  industrytypeId: null,
  sourceId: null,
  contactPersonName: "",
  designationId: null,
  companyEmail: "",
  companySize: "",
  // destinationMarket: "",
  socialLinks: [{ socialLink: "" }],
};

export enum BussinessType {
  B2B = 1,
  B2C = 2,
  C2C = 3,
  C2B = 4,
  B2G = 5,
  G2B = 6,
  G2C = 7,
  C2G = 8,
  D2C = 9,
  B2B2C = 10,
  P2P = 11,
  SaaS = 12,
}

export const BussinessTypeOptions = [
  { id: BussinessType.B2B, name: "B2B" },
  { id: BussinessType.B2C, name: "B2C" },
  { id: BussinessType.C2C, name: "C2C" },
  { id: BussinessType.C2B, name: "C2B" },
  { id: BussinessType.B2G, name: "B2G" },
  { id: BussinessType.G2B, name: "G2B" },
  { id: BussinessType.G2C, name: "G2C" },
  { id: BussinessType.C2G, name: "C2G" },
  { id: BussinessType.D2C, name: "D2C" },
  { id: BussinessType.B2B2C, name: "B2B2C" },
  { id: BussinessType.P2P, name: "P2P" },
  { id: BussinessType.SaaS, name: "SaaS" },
];

export enum ChannelType {
  GoogleAds = 1,
  FacebookAds = 2,
  Instagram = 3,
  LinkedIn = 4,
  OfflineMarketing = 5,
}

export const ChannelTypeOptions = [
  { id: ChannelType.GoogleAds, name: "Google Ads" },
  { id: ChannelType.FacebookAds, name: "Facebook Ads" },
  { id: ChannelType.Instagram, name: "Instagram" },
  { id: ChannelType.LinkedIn, name: "LinkedIn" },
  { id: ChannelType.OfflineMarketing, name: "Offline Marketing" },
];

export const YearsInBusinessOptions = Array.from(
  { length: 201 },
  (_, i) => ({
    id: i,
    name: i.toString(),
  })
);

